import React, { useState, useEffect } from 'react';
import { db, getFromDB } from "../../firebase";
import { doc, getDoc } from 'firebase/firestore';
import { useLocation, useNavigate } from 'react-router-dom'

import {Utils} from '../utils/Utils'

import './Player.css'

function Player() {
  const location = useLocation()
  const navigate = useNavigate();
  const {idPlayer, idTeam} = location.state
  const [team, setTeam] = useState({})
  const [player, setPlayer] = useState({})
  const [country, setCountry] = useState({})
  const [country2, setCountry2] = useState({})
  const [countryLastTeam, setCountryLastTeam] = useState({})

  useEffect(() => {
    const getTeamAndPlayerFromFirestore = async () => {
      try {
        const docRef = doc(db, 'teams', idTeam);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setTeam(docSnap.data())
          const playerList = docSnap.data().players
          if (playerList !== undefined) {
            const playerFound = playerList.filter(itemPlayer => itemPlayer.id === idPlayer )[0]
            setPlayer(playerFound)
            return playerFound
          } else {
            console.error("Error al obtener el listado de jugadores del equipo");
          }
          return null
        }
      } catch (error) {
        console.error('Error al obtener los datos del equipo '+idTeam+': ', error);
      }
    };

    const getCountryFromFirestore = async (countryName, type) => {
      try {
        const queryData = {table: 'countries', conditions: {field: 'name', operator: '==', value: countryName}}
        const dataResults = await getFromDB(queryData)
        if (dataResults !== undefined && dataResults.length > 0) {
          if (type === "nat1") {
            setCountry(dataResults[0])
          } else if (type === "nat2") {
            setCountry2(dataResults[0])
          } else if (type === "lastTeam"){
            setCountryLastTeam(dataResults[0])
          }
        }
      } catch (error) {
        console.error('Error al obtener los datos del país:', error);
      }
    };

    getTeamAndPlayerFromFirestore().then(playerFound => {
      getCountryFromFirestore(playerFound.nationality, "nat1")
      if (playerFound.nationality2 !== "") {
        getCountryFromFirestore(playerFound.nationality2, "nat2")
      }
      if (playerFound.countryLastTeam !== "") {
        getCountryFromFirestore(playerFound.countryLastTeam, "lastTeam")
      }
    });
    
  }, [idPlayer, idTeam]);

  const showPhoto = url => {
    if (url !== '') {
      return <img className="photo-big" src={url} alt={url}></img>
    } else {
      return <></>
    }
  }

  const goBack = () => {
    navigate(-1)
  }

  const getPositionName = () => {
    if(player !== undefined && player.position !== undefined && player.position !== "") {
      const position = Utils.getPositionById(player.position)
      if (position !== null) {
        return position.position.name
      }
    }
    return <></>
  }

  const getHeight = () => {
    if (player.height !== undefined) {
      return Number(player.height).toFixed(2)
    }
  }

  const showFlagCountry = type => {
    let countryFlag 
    if (type === "nat1") {
      countryFlag = country
    } else if (type === "nat2" && country2.path !== undefined ) {
      countryFlag = country2
    } else if (type === "lastTeam" && countryLastTeam.path !== undefined) {
      countryFlag = countryLastTeam
    }

    if (countryFlag !== undefined) {
      return <img className="country-flag" src={`./assets/flags/${countryFlag.path}`} alt={countryFlag.path}></img>
    } else {
      return <></>
    }
  }

  const showNationality = () => {
    if (player.nationality2 !== "") {
      return <>{player.nationality} {showFlagCountry("nat1")} / {player.nationality2} {showFlagCountry("nat2")}</>
    } else {
      return <>{player.nationality} {showFlagCountry("nat1")}</>
    }
  }

  const showAverage = item => {
    return Utils.decimalDiv(item,player.numMatches,1)
  }

  const showPercentage = (a, b) => {
    return b>0 ? Number((a/b)*100).toFixed(1) + '%' : ''
  }

  const showAverageMinutes = () => {
    if (player.minutes !== undefined && player.numMatches > 0) {
      const minutesArr = player.minutes.split(":")
      if (minutesArr.length === 2) {
        const minutes = minutesArr[0] * 1
        const seconds = minutesArr[1] * 1
        const minutesDec = minutes + seconds/60 
        const minutesAvg = Math.trunc(minutesDec / player.numMatches)
        const secondsAvg = Math.round((minutesDec / player.numMatches - minutesAvg) * 0.6 * 100);
        return minutesAvg+":"+secondsAvg
      }
    }
    return ""
  }

  const showLastTeam = () => {
    if (player !== undefined && player.lastTeam !== undefined && player.lastTeam.toLowerCase() !== "sin equipo") {
      return <>{player.lastTeam} ({player.categoryLastTeam} {showFlagCountry("lastTeam")})</>
    } else {
      return <>{player.lastTeam}</>
    }
  }

  const showStatsLastYear = () => {
    if (player !== undefined && player.lastTeam !== undefined && player.lastTeam.toLowerCase() !== "sin equipo") {
      return <>
        <table className="table-averages">
          <thead>
            <tr>
              <th>Part</th>
              <th>Mins</th>
              <th>Pts</th>
              <th>Rebs</th>
              <th>Asis</th>
              <th>Robos</th>
              <th>Perd</th>
              <th>Taps</th>
            </tr>
          </thead>
          <tbody>
            <td>{player.numMatches}</td>
            <td>{showAverageMinutes()}</td>
            <td>{showAverage(player.points)}</td>
            <td>{showAverage(player.rebounds)}</td>
            <td>{showAverage(player.assists)}</td>
            <td>{showAverage(player.steals)}</td>
            <td>{showAverage(player.turnovers)}</td>
            <td>{showAverage(player.blocks)}</td>
          </tbody>
        </table>
        <table className="table-shooting">
          <thead>
            <tr>
              <th>T2</th>
              <th>T3</th>
              <th>TL</th>
              <th>TS</th>
              <th>eFG</th>
              <th>3Par</th>
            </tr>
          </thead>
          <tbody>
            <td>{showAverage(player.fg2m)}/{showAverage(player.fg2a)} {showPercentage(player.fg2m,player.fg2a)}</td>
            <td>{showAverage(player.fg3m)}/{showAverage(player.fg3a)} {showPercentage(player.fg3m,player.fg3a)}</td>
            <td>{showAverage(player.ftm)}/{showAverage(player.fta)} {showPercentage(player.ftm,player.fta)}</td>
            <td>{showPercentage(player.points, 2 * (player.fg2a+player.fg3a + (0.44 * player.fta)))}</td>
            <td>{showPercentage(player.fg2m+player.fg3m+0.5*player.fg3m,player.fg2a+player.fg3a)}</td>
            <td>{showPercentage(player.fg3a,player.fg2a+player.fg3a)}</td>
          </tbody>
        </table>
      </>
    } else {
      return <></>
    }
  }

  return (
    <div>
      <div className="header">
        <div className="header-left">  
          <h2>{player.name}</h2>
        </div>
        <div className="header-right"><button className="btn-go-back" onClick={goBack}>Volver</button></div>
      </div>
      <div className="container-player">
        <div className="data-player">
          <div className="first-info">
            <div className="photo-player">{showPhoto(player.urlPhoto)}</div>
            <div className="name-team">
              <img className="logo-team-big" src={team.url_logo} alt={team.url_logo}></img>
              <span className="name-team-span">{team.name}</span>
            </div>
          </div>
          <div className="info-player">
            <div>Posición: {getPositionName()}</div>
            <div>Fecha de nacimiento: {player.birthDate} ({Utils.getAge(player.birthDate)} años)</div>
            <div>Altura: {getHeight()} m</div>
            <div>Nacionalidad: {showNationality()} ({Utils.getLicence(player.licence)})</div>
            <div className="last-season-player">
              <div>Temporada 2025/2026</div>
              <div>Equipo: {showLastTeam()} </div>
              {showStatsLastYear()}
            </div>
            <div><a target="_blank" href={player.urlStats} rel="noreferrer">Más info</a></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Player